<template>
   <wo-dropdown v-if="options" :mod-right="modRight">
    <wo-button slot="toggle" mod-secondary mod-icon mod-icon-after icon="chevron-down">
      <po-display :value="value" />
    </wo-button>
    <template slot="links">
      <wo-link v-for="(option, index) in options" :key="index" @click.native.prevent="select(option)"
        :mod-icon="!!option.icon" :mod-icon-before="!!option.icon" :icon="option.icon"><po-display :value="option" /></wo-link>
    </template>
  </wo-dropdown>
</template>
<script>

export default {
  name: 'PoToggleButton',
  props: {
    options: Array,
    value: Object,
    modRight: Boolean
  },
  methods: {
    select (item) {
      this.$emit('input', item)
    }
  }
}
</script>
